import axios from "axios";
import { ACCOUNT_TYPE_NORMAL, API_BASE_URL } from "@config/config";

export const toggleWatchlist = (movieId, user, callback, errorCallback) => {
    if (!user || user.account_type_id !== ACCOUNT_TYPE_NORMAL) {
        return;
    }

    axios
        .post(`${API_BASE_URL}/watchlist/toggle`, { movie_id: movieId })
        .then(function(response) {
            const { in_watchlist, action } = response.data;
            if (callback) {
                callback(in_watchlist, action);
            }
        })
        .catch(({ response }) => {
            if (response?.status === 401) {
                window.location = "/";
                return;
            }

            if (callback) {
                callback(null, "error");
            } else if (errorCallback) {
                errorCallback(null, "error");
            }
        });
};

export const fetchWatchlistStatus = (movieIds, user, callback) => {
    if (!movieIds || movieIds.length === 0) return;

    if (!user || user.account_type_id !== ACCOUNT_TYPE_NORMAL) {
        return;
    }

    axios
        .post(`${API_BASE_URL}/watchlist/status`, { movie_ids: movieIds })
        .then(function(response) {
            const watchlistStatus = response.data.data;
            if (callback) {
                callback(watchlistStatus || {});
            }
        })
        .catch(({ response }) => {
            if (response?.status === 401) {
                window.location = "/";
                return;
            }

            if (callback) {
                callback(null);
            }
        });
};
